// Generated types for FunctionalBlockExtractionTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { EntityExtractionTaskReadAPI, EntityExtractionTaskWriteAPI } from './entityextractiontask';
import { EntityExtractionTaskReadAPISchemaObject, EntityExtractionTaskWriteAPISchemaObject } from './entityextractiontask';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface FunctionalBlockExtractionTaskReadAPI extends EntityExtractionTaskReadAPI {
}

export interface FunctionalBlockExtractionTaskWriteAPI extends EntityExtractionTaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const FunctionalBlockExtractionTaskReadAPISchema: z.ZodType<FunctionalBlockExtractionTaskReadAPI> = EntityExtractionTaskReadAPISchemaObject.extend({}).passthrough();

export const FunctionalBlockExtractionTaskWriteAPISchema: z.ZodType<FunctionalBlockExtractionTaskWriteAPI> = EntityExtractionTaskWriteAPISchemaObject.extend({}).passthrough();
